import { graphqlRequest } from "./graphql";

export interface BBPSOperator {
  code: string;
  image: string;
  service: string;
  name: string;
  discount_percentage: number;
}

interface GetBBPSOperatorsResponse {
  whatsub_bbps_operators: BBPSOperator[];
  whatsub_bbps_operators_aggregate: { aggregate: { count: number } };
}

export interface BBPSFilters {
  service?: string;
  search?: string;
}

function buildWhere(filters: BBPSFilters): Record<string, unknown> {
  const where: Record<string, unknown> = { active: { _eq: true } };
  if (filters.service) where["service"] = { _eq: filters.service };
  if (filters.search) where["name"] = { _ilike: `%${filters.search}%` };
  return where;
}

export async function getBBPSOperators(
  filters: BBPSFilters,
  limit: number,
  offset: number,
  token: string
) {
  const query = `
    query GetBBPSOperators($limit: Int!, $offset: Int!, $where: whatsub_bbps_operators_bool_exp) {
      whatsub_bbps_operators(
        limit: $limit,
        offset: $offset,
        where: $where,
        order_by: { discount_percentage: desc }
      ) {
        code
        image
        service
        name
        discount_percentage
      }
      whatsub_bbps_operators_aggregate(where: $where) {
        aggregate { count }
      }
    }
  `;
  const data = await graphqlRequest<GetBBPSOperatorsResponse>(
    query,
    { limit, offset, where: buildWhere(filters) },
    token
  );
  return {
    operators: data.whatsub_bbps_operators,
    total: data.whatsub_bbps_operators_aggregate.aggregate.count,
  };
}
